import baseApi from '@store/api/baseApi';

import { downloadBlobFileWithRTKQuery } from '@/utils/Util';

export const commonDownloadsApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		// Download Techpack Summary (excel file)
		downloadTpSummary: builder.query({
			query: ({ productIds }) => ({
				url: `/collection/download-report?productIds=${productIds.join(',')}`,
				headers: {
					'Content-Disposition': 'attachment'
				},
				responseType: 'blob',
				responseHandler: async (response) => {
					await downloadBlobFileWithRTKQuery(response);
				},
				keepUnusedDataFor: 0
			})
		}),
		// Download Sample Sticker
		downloadSticker: builder.mutation({
			query: ({ body, productIds, sampleIdentifierNos }) => ({
				url: `/product-sample-inventory/sticker/download?productIds=${productIds.join(',')}&sampleIdentifierNos=${sampleIdentifierNos.join(',')}`,
				method: 'POST',
				body,
				responseHeaders: async (response) => {
					window.open(response.url, '_blank');
				},
				keepUnusedDataFor: 0
			})
		})
	})
});

export const { useLazyDownloadTpSummaryQuery, useDownloadStickerMutation } = commonDownloadsApi;
